import React from 'react';

interface ParagraphProps {
  text: string;
}

const Paragraph: React.FC<ParagraphProps> = ({ text }) => {
  if (!text) return null;

  return (
    <>
      {text.split('\n').map((str, index) => (
        <React.Fragment key={index}>
          {str}
          {index !== text.split('\n').length - 1 && <br />}
        </React.Fragment>
      ))}
    </>
  );
};

export default Paragraph;
